Revolution.Module.extend({
  NAME: "mde.cookiefirst", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/view-password.js)

  initialize: function ($) {
    //events
    $(document).ready(function() {
      this.updateTitleTags();
    }.bind(this));
    window.addEventListener("cf_init", this.updateTitleTags);
  },

  updateTitleTags: function (e) {
    var h4Tags = document.querySelectorAll('#cookiefirst-policy-page h4');

    h4Tags.forEach(function(tag) {
      tag.classList.add('turquoise-color');
    });

    var h3Tags = document.querySelectorAll('#cookiefirst-policy-page h3, .cookiefirst-cookie-declaration h3');

    h3Tags.forEach(function(tag) {
      var h5Tag = document.createElement('h5');
      h5Tag.classList.add('turquoise-color');
      h5Tag.innerHTML = tag.innerHTML;

      tag.parentNode.replaceChild(h5Tag, tag);
    });

    var h2Tags = document.querySelectorAll('#cookiefirst-policy-page h2, .cookiefirst-cookie-declaration h2');

    h2Tags.forEach(function(tag) {
      var h4Tag = document.createElement('h4');
      h4Tag.classList.add('turquoise-color');
      h4Tag.innerHTML = tag.innerHTML;

      tag.parentNode.replaceChild(h4Tag, tag);
    });
  },
});
